import {
  matchTypes,
  ProviderSearchQueryMatchType,
  ProviderSearchValues,
} from '@/components/ProviderSearch/ProviderSearchForm/types';
import useQueryString from '@/hooks/useQueryString';
import { filterEmptyValues } from '@/lib/utils/object';

/**
 * useProviderSearchInputQueryParams
 *
 * Returns the common query parameters used to initiate a search for providers.
 *
 * @returns Describe the hook return value.
 */
export const useProviderSearchInputQueryParams = () => {
  const { query, location, matchId, matchType, latitude, longitude } =
    useQueryString(
      'query',
      'matchId',
      'matchType',
      'location',
      'latitude',
      'longitude'
    );

  const validatedMatchType = matchTypes.includes(
    matchType as ProviderSearchQueryMatchType
  )
    ? (matchType as ProviderSearchQueryMatchType)
    : undefined;

  return {
    query: query ? decodeURIComponent(query) : undefined,
    location,
    matchId: (validatedMatchType && matchId) || undefined,
    matchType: (matchId && validatedMatchType) || undefined,
    latitude: Number(latitude) ? Number(latitude) : undefined,
    longitude: Number(longitude) ? Number(longitude) : undefined,
  };
};

export const encodeQueryParams = ({ query, location }: ProviderSearchValues) =>
  filterEmptyValues({
    query: query.text,
    matchId: query.matchId,
    matchType: query.matchType,
    location: location.text,
    latitude: location.latitude,
    longitude: location.longitude,
  });
